<div class="flex flex-col">
    <div class="flex flex-row gap-2 p-1 text-xs sm:text-sm rounded-sm shadow-sm bg-white items-center">
        <input #filterInput 
            (click)="isOpen = true"
            (input)="onFilterChange(filterInput.value)" 
            type="text" 
            class=" disabled:text-slate-400 grow bg-transparent focus:outline-none" 
            placeholder="{{ placeholder }}">
        <button (click)="isOpen = !isOpen">
            <svg-icon [svgIcon]="isOpen ? isOpenSvgIcon : isClosedSvgIcon" [small]="true" class="fill-none stroke-slate-900"></svg-icon>
        </button>
    </div>
    @if (isOpen) {
        <div class="relative text-xs sm:text-sm">
            <div class="flex flex-col absolute w-full z-10 bg-white rounded-sm shadow max-h-80 overflow-auto mt-1">
                @for (kvp of visibleItems ; track kvp.key) {
                    <div (click)="onValueClicked(kvp)" class="hover:bg-ponder-linkhover hover:text-white hover:cursor-default p-1 select-none">{{ kvp.key }}</div>
                }
            </div>
        </div>
    }
</div>